/**
 * Resolved color values for one palette mode.
 *
 * Maps Elementor global color ids to CSS color values for a single mode.
 */
export class ColorPalette {
	private readonly modeKey: string;

	private readonly colorMap: Readonly<Record<string, string>>;

	private readonly customColorIds: ReadonlySet<string>;

	constructor(
		modeKey: string,
		colorMap: Record<string, string>,
		customColorIds: string[] = []
	) {
		this.modeKey = modeKey;
		this.colorMap = { ...colorMap };
		this.customColorIds = new Set(customColorIds);
	}

	key(): string {
		return this.modeKey;
	}

	map(): Readonly<Record<string, string>> {
		return this.colorMap;
	}

	colorForKey(colorId: string): string | null {
		return this.colorMap[colorId] ?? null;
	}

	isCustomColor(colorId: string): boolean {
		return this.customColorIds.has(colorId);
	}
}
